import { Routes, Route } from "react-router-dom";
import Menu from './components/Menu';
import Footer from './components/Footer';
import Home from './pages/home';
import Agenda from './pages/agenda';
import Speakers from "./pages/speakers";
import WhoAttends from "./pages/who-attends";
import Sponsors from "./pages/sponsors";
import AboutUs from "./pages/about-us";
import Venue from './pages/venue';
import './App.css';

function App() {
  return (
    <div className="App">
      <Menu />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/speakers" element={<Speakers />} />
        <Route path="/who-attends" element={<WhoAttends />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/venue" element={<Venue />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
